import CashAdvanceFeesOverpanel from './cashAdvanceFeesOverpanel'

export default CashAdvanceFeesOverpanel
